import { useContext } from 'react';
import { FeatureFlagsContext } from '@core-ui/feature-flags';

const useFeatureVariables = (
  feature: string
): { [key: string]: any } | undefined => {
  const { featureVariables } = useContext(FeatureFlagsContext);

  return featureVariables?.[feature];
};

export default useFeatureVariables;
